module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABmSURBVHgB7dWxCYBADEbhHydwBEdxhNvAbKYjukFMEdHyCiHgvQeBaw4+0kQi+lvuvsTsMU2VBcD8aVNlATjAgAEDZlTM2vtv0vf5632qojyKd6aKQIAAAaID0coRCZlzIyaikbsA7CdPJKDwZx0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/c21/ico-btn-arrow.png
// module id = FMBI
// module chunks = 1